export default function ({ store, redirect }) {
  if (!store.getters['user/isLoggedin']) {
    return redirect('/')
  }
}
